import MDBox from "components/MDBox";
import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Card,
  Grid,
  CircularProgress,
  Typography,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Fab,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SystemSecurityUpdateIcon from "@mui/icons-material/SystemSecurityUpdate";
import MDTypography from "components/MDTypography";
import { appTelemetry } from "globals/endpoints";
import { useMaterialUIController } from "context";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import MDButton from "components/MDButton";
import CTLNotification from "application/components/CTLNotification";
import AuthenticationService from "application/modules/authentication/AuthenticationService";

const releasePPDRClient = ({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) => {
  const [list, setList] = useState([]);
  const [controller] = useMaterialUIController();
  const { activePage, darkMode } = controller;
  const [filteredContactList, setFilteredContactList] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    pagename:"",
    type: "",
  });
  const fileInputRef = useRef(null);
  const Attributes = {
    enableAddButton: !AuthenticationService.isViewOnlyUser(),
    modes: [],
  };

  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks &&
      registerCallBacks({
        openForm: onOpenForm,
      });
    fetchContactList();
  }, [activePage]);

  const fetchContactList = async () => {
    try {
      const response = await appTelemetry.post(`auth/listApkFiles`);
      setList(response.data.data);
    } catch (error) {
      console.error("Unable to get Contact List", error);
    }
  };

  const handleFileChange = (e) => {
    const newFile = e.target.files[0];
    if (newFile) {
      setSelectedFile(newFile.name);
      setFile(newFile);
      e.target.value = "";
    }
  };

  const handleFileRemove = () => {
    setSelectedFile(null);
    setFile(null);
  };

const handleFileUpload = () => {

  if (file.type !== "application/vnd.android.package-archive") {
    setNotify({
      isOpen: true,
      pagename: pageName,
      message: "Invalid file type. Please upload an APK file.",
      type: "error",
    });
    return;
  }

  setUploading(true);
  const formData = new FormData();
  formData.append("file", file);

  appTelemetry
    .post("auth/upload/apkFile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      setNotify({
        isOpen: true,
        pagename:pageName,
        message: response.data.message,
        status: response.data.messageDetail || "File uploaded successfully",
        type: "success",
      });
      fetchContactList();
      setOpenForm(false);
      setFile(null);
    })
    .catch((error) => {
      console.error("File upload error:", error);
      setNotify({
        isOpen: true,
        pagename: pageName,
        message: error.response?.data?.message,
        status: error.response?.data?.messageDetail || "File upload failed",
        type: "error",
      });
    })
    .finally(() => {
      setUploading(false);
    });
};

  useEffect(() => {
    if (searchText) {
      setFilteredContactList(
        list.filter(
          (item) =>
            item.fileName &&
            item.fileName.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    } else {
      setFilteredContactList(list);
    }
  }, [searchText, list]);

  const onOpenForm = () => setOpenForm(true);
  const onCloseForm = () => setOpenForm(false);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}/${month}/${year} - ${hours}:${minutes} ${ampm}`;
  }


  return (
    <div>
      <Dialog
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
        open={openForm}
        onClose={onCloseForm}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          Upload Application File
        </DialogTitle>
        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <input
            ref={fileInputRef}
            type="file"
            accept=".apk"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {!selectedFile ? (
            <Fab
              color="info"
              size="medium"
              component="span"
              variant="extended"
              onClick={() => fileInputRef.current.click()}
            >
              + Add Application File
            </Fab>
          ) : (
            <MDTypography variant="h6">
              {selectedFile} &nbsp;
              <IconButton color="error" size="small" onClick={handleFileRemove}>
                <ClearIcon />
              </IconButton>
              {uploading ? (
                <>
                  &nbsp; &nbsp;
                  <CircularProgress color="info" size={24} />
                  &nbsp; Uploading...
                </>
              ) : (
                <MDButton color="info" size="small" onClick={handleFileUpload}>
                  Upload File
                </MDButton>
              )}
            </MDTypography>
          )}
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={onCloseForm} color="error">
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>

      <MDBox
        style={{
          position: "sticky",
          top: 60,
          zIndex: 1,
          paddingBottom: "10px",
        }}
      >
        <Card style={{ backgroundColor: "gray", padding: "10px" }}>
          <Grid container alignItems="center">
            <Grid item xs={6}>
              <MDTypography variant="h6">Application Version</MDTypography>
            </Grid>
            <Grid item xs={6}>
              <MDTypography variant="h6">Release Date</MDTypography>
            </Grid>
          </Grid>
        </Card>
      </MDBox>

      <MDBox
        style={{
          height: "70vh",
          overflowY: "auto",
        }}
      >
        {filteredContactList.length === 0 ? (
          <Card style={{ height: "100%" }}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircularProgress color="info" />
              &nbsp;&nbsp;
              <Typography variant="h6" color="text">
                Loading...
              </Typography>
            </Box>
          </Card>
        ) : (
          <Grid container spacing={1}>
            {filteredContactList
              .sort((a, b) => new Date(b.uploadedOn) - new Date(a.uploadedOn))
              .map((item) => (
                <Grid item xs={12} key={item.id}>
                  <Card>
                    <Box p={1}>
                      <Grid container alignItems="center">
                        <Grid item xs={6}>
                          <MDTypography variant="caption text">
                            <SystemSecurityUpdateIcon
                              color="info"
                              fontSize="medium"
                            />
                            &nbsp;&nbsp;
                            {item.fileName}
                          </MDTypography>
                        </Grid>
                        <Grid item xs={6}>
                          <MDTypography variant="caption text">
                            {formatDate(item.uploadedOn)}
                          </MDTypography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Card>
                </Grid>
              ))}
          </Grid>
        )}
        <CTLNotification notify={notify} setNotify={setNotify} />
      </MDBox>
    </div>
  );
};

export default releasePPDRClient;
